import React from "react";

// Um erro de renderização em qualquer canto derrubava a aplicação inteira: tela
// branca, sem mensagem, sem como o usuário se recuperar a não ser recarregando —
// e sem nenhuma pista para quem vai consertar.
//
// Esta barreira segura o erro, mostra o que aconteceu e oferece as duas saídas
// (voltar e recarregar). O detalhe técnico fica recolhido: quem só quer usar não
// precisa ver, e quem vai consertar copia com um clique.
class BarreiraDeErro extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, pilha: null, aberto: false, copiado: false };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    this.setState({ pilha: info?.componentStack || "" });
    // Mantém o rastro no console para quem estiver com ele aberto
    console.error("[BarreiraDeErro]", erro, info?.componentStack);
  }

  detalhe() {
    const { erro, pilha } = this.state;
    return [
      `Mensagem: ${erro?.message || erro}`,
      `Endereço: ${window.location.href}`,
      "",
      erro?.stack || "",
      "",
      "Componentes:",
      pilha || ""
    ].join("\n");
  }

  copiar = () => {
    const texto = this.detalhe();
    const feito = () => {
      this.setState({ copiado: true });
      setTimeout(() => this.setState({ copiado: false }), 2500);
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(texto).then(feito).catch(() => {});
      return;
    }
    // Navegador antigo ou página sem permissão de área de transferência
    const campo = document.createElement("textarea");
    campo.value = texto;
    document.body.appendChild(campo);
    campo.select();
    try {
      document.execCommand("copy");
      feito();
    } catch (e) {
      /* sem o que fazer: o texto está visível na tela para copiar à mão */
    }
    document.body.removeChild(campo);
  };

  render() {
    const { erro, aberto, copiado } = this.state;
    if (!erro) return this.props.children;

    const botao = {
      border: "none",
      borderRadius: 8,
      padding: "10px 18px",
      fontSize: 14,
      cursor: "pointer",
      fontFamily: "inherit"
    };

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          background: "#f0f2f5",
          fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif"
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            padding: 28,
            maxWidth: 560,
            width: "100%",
            boxShadow: "0 10px 40px rgba(0,0,0,.10)"
          }}
        >
          <div style={{ fontSize: 34, marginBottom: 12 }}>&#128533;</div>
          <h1 style={{ fontSize: 20, margin: "0 0 8px", color: "#111827" }}>
            Algo deu errado nesta tela
          </h1>
          <p
            style={{
              fontSize: 14,
              color: "#4b5563",
              margin: "0 0 20px",
              lineHeight: 1.6
            }}
          >
            O resto da plataforma continua funcionando. Você pode voltar e tentar
            de novo — se acontecer outra vez, copie o detalhe abaixo e mande para
            o suporte.
          </p>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              onClick={() => window.history.back()}
              style={{ ...botao, background: "#2563EB", color: "#fff" }}
            >
              Voltar
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{ ...botao, background: "#e5e7eb", color: "#111827" }}
            >
              Recarregar
            </button>
            <button
              onClick={this.copiar}
              style={{ ...botao, background: "#e5e7eb", color: "#111827" }}
            >
              {copiado ? "Copiado!" : "Copiar detalhe"}
            </button>
          </div>

          <button
            onClick={() => this.setState({ aberto: !aberto })}
            style={{
              ...botao,
              background: "transparent",
              color: "#6b7280",
              padding: "12px 0 0",
              fontSize: 13,
              textDecoration: "underline"
            }}
          >
            {aberto ? "Esconder detalhe técnico" : "Ver detalhe técnico"}
          </button>

          {aberto && (
            <pre
              style={{
                marginTop: 12,
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: 12,
                fontSize: 11,
                lineHeight: 1.5,
                color: "#374151",
                maxHeight: 260,
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {this.detalhe()}
            </pre>
          )}
        </div>
      </div>
    );
  }
}

export default BarreiraDeErro;
